import type { OnInit } from '@angular/core';
import { Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import { SpecialDayFetcher } from '../special-day.fetcher';
import { SpecialDayPresenter } from '../special-day.presenter';

@Component({
    selector: 'app-special-day-select',
    styleUrls: ['./special-day-select.component.scss'],
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SpecialDaySelectComponent), multi: true }],
})
export class SpecialDaySelectComponent extends BaseSelectFormFieldComponent<string> implements OnInit {
    @Input() fetchFromApi = true;

    constructor(element: ElementRef<any>,
                renderer: Renderer2,
                private fetcher: SpecialDayFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this._fetch();
    }

    private _fetch() {
        if (!this.fetchFromApi) {
            return;
        }

        const params = {
            order_by: 'date',
            direction: 'asc',
        };

        this.fetcher.all(params).subscribe(response => {
            this.apiOptions = SpecialDayPresenter.attachCollection(response.data).map(specialDay => ({
                label: specialDay.name,
                value: specialDay.id
            }));
        });
    }
}
